import { render, staticRenderFns } from "./Parts.vue?vue&type=template&id=0e8022d8&scoped=true&"
import script from "./Parts.vue?vue&type=script&lang=js&"
export * from "./Parts.vue?vue&type=script&lang=js&"
import style0 from "./Parts.vue?vue&type=style&index=0&id=0e8022d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8022d8",
  null
  
)

export default component.exports